<template>
  <div v-if="isLoaded">
    <b-card class="pt-3 mx-auto login-form-card" header-tag="header">
      <h5 slot="header" class="mb-0" align="center">
        {{ isActive ? 'Восстановление пароля' : 'Регистрация в системе'}}
      </h5>
      <b-form
        @submit.prevent="onSubmit"
      >

        <b-form-group label="Фамилия" v-if="!isActive">
          <b-form-input
            v-model.lazy="form.surname"
            type="text"
            required
            placeholder="Введите фамилию"
          ></b-form-input>
          <b-form-text class="validationError" v-show="surnameOk === false">
            Некорректно введена фамилия
          </b-form-text>
        </b-form-group>
        <b-form-group label="Имя" v-if="!isActive">
          <b-form-input
            v-model.lazy="form.name"
            type="text"
            required
            placeholder="Введите имя"
          ></b-form-input>
          <b-form-text class="validationError" v-show="nameOk === false">
            Некорректно введено имя
          </b-form-text>
        </b-form-group>
        <b-form-group label="Отчество" v-if="!isActive">
          <b-form-input
            v-model.lazy="form.midname"
            type="text"
            placeholder="Введите отчество"
            autocomplete="off"
          ></b-form-input>
          <b-form-text class="validationError" v-show="midnameOk === false">
            Некорректно введено отчество
          </b-form-text>
        </b-form-group>
        <b-form-group label="Пароль">
          <b-form-input
            v-model="form.password"
            type="password"
            required
            autocomplete="off"
            minlength="12"
            v-b-tooltip.hover
            title="Для большей надёжности рекомендуется использовать буквы разных регистров и цифры"
            placeholder="Введите пароль"
            @focus="onPasswordFocus"
          ></b-form-input>
          <b-form-text :class="passwordValid === false ? 'validationError' : ''">
            Минимальная длина пароля 12 символов
          </b-form-text>
        </b-form-group>
        <b-form-group id="input-group-login-password" label="Повторите пароль">
          <b-form-input
            v-model="form.passwordConfirm"
            type="password"
            required
            minlength="12"
            placeholder="Повторите пароль"
            @focus="onPasswordFocus"
          ></b-form-input>
          <b-form-text class="validationError" v-show="passwordConfirm === false">
            Пароли не совпадают
          </b-form-text>
        </b-form-group>
        <div>
          <template v-if="!isActive">
            <b-form-checkbox
              v-model="form.isAgreePersonalDataProcessing"
              class="float-left"
              style="display: inline-block">
              Согласие на обработку персональных данных
            </b-form-checkbox> <br>
            <b-form-text
              class="float-left validationError"
              v-show="form.isAgreePersonalDataProcessing === false"
            >
              Необходимо согласие на обработку персональных данных
            </b-form-text>
          </template>
          <div align="right">
            <b-button
              type="submit"
              variant="outline-primary"
              style="width: 200px"
              align="center"
              class="float-right"
            >
              <em class="fas fa-sign-in" aria-hidden="true"></em> Войти
            </b-button>
          </div>
        </div>
      </b-form>
    </b-card>
  </div>
</template>

<script>

import { mapActions } from 'vuex'
import { regexp } from '@/config/regexp'

import confirmationApi from '@/api/confirmation'

export default {
  name: 'Confirmation',
  data() {
    return {
      isActive: false,
      isLoaded: false,
      form: {
        password: '',
        passwordConfirm: '',
        surname: '',
        name: '',
        midname: '',
        isAgreePersonalDataProcessing: null,
        activationCode: '',
        userId: null
      },
      passwordConfirm: null,
      passwordValid: null,
      nameOk: null,
      surnameOk: null,
      midnameOk: null,
      nameRegExp: regexp.name
    }
  },
  beforeCreate() {
    new Promise((resolve, reject) => {
      confirmationApi.codeValidation(this.$route.params.code)
        .then((response) => {
          this.form.userId = response.data.id
          this.form.name = response.data.name
          this.form.surname = response.data.surname
          this.form.midname = response.data.midname
          this.form.activationCode = this.$route.params.code
          this.isLoaded = true
          this.isActive = response.data.active
          this.form.isAgreePersonalDataProcessing = response.data.active
          resolve()
        })
        .catch((error) => {
          this.$router.push('/invalid-code')
          this.pushToasts({
            title: 'Уведомление',
            error: true,
            message: 'Ссылка для регистрации недействительна!',
            time: 5
          })
          reject(error)
        })
    }).catch(() => {})
  },
  methods: {
    async onSubmit() {
      this.passwordValid = this.form.password.length >= 12
      this.passwordConfirm = this.form.password === this.form.passwordConfirm

      if (this.form.isAgreePersonalDataProcessing !== true) {
        this.form.isAgreePersonalDataProcessing = false
      }
      this.form.surname = this.form.surname.trim()
      this.form.name = this.form.name.trim()
      this.form.midname = this.form.midname.trim()
      if (this.passwordConfirm === true && this.passwordValid === true
        && (this.form.isAgreePersonalDataProcessing === true || this.isActive)) {
        this.nameOk = !!this.form.name.match(this.nameRegExp)
        this.surnameOk = !!this.form.surname.match(this.nameRegExp)
        this.midnameOk = !this.form.midname || !!this.form.midname.match(this.nameRegExp)
        if (this.nameOk && this.surnameOk && this.midnameOk) {
          new Promise((resolve, reject) => {
            confirmationApi.signUp(this.form.midname ? this.form : {
              ...this.form,
              midname: null
            })
              .then(() => {
                this.pushToasts({
                  title: 'Уведомление',
                  message: this.isActive
                    ? 'Восстановление пароля прошло успешно!'
                    : 'Регистрация прошла успешно!'
                })
                this.$router.push('/login')
                resolve()
              })
              .catch((error) => {
                this.pushToasts({
                  title: 'Уведомление',
                  error: true,
                  message: 'Не удалось завершить регистрацию!'
                })
                reject(error)
              })
          })
        }
      }
    },
    onPasswordFocus() {
      this.passwordConfirm = null
      this.passwordValid = null
    },
    ...mapActions({
      pushToasts: 'toasts/pushToasts'
    })
  }
}
</script>

<style scoped>

  .card-header{
    background-color: #017ac3;
    color: white;
  }

  .card{
    width: 60vw;
    max-width: 900px;
    min-width: 485px;
  }

  .validationError {
    color: red !important;
  }
</style>
